import React, { useEffect, useState, useRef, useMemo } from "react";
import { setCurrentPageTitle } from "../../store/slices/pageSlice";
import { useDispatch, useSelector } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
// import RemoveIcon from "@mui/icons-material/Remove";
import {
  createQuotation,
  deleteQuotation,
  fetchQuotations,
  updateQuotation,
} from "../../store/slices/hourlyRates";
import { useSnackbar } from "notistack";
import AdminLoader from "../../components/common/loader/AdminLoader";
import {
  createOtherExpense,
  deleteOtherExpense,
  fetchOtherExpenses,
} from "../../store/slices/otherexpenses";
import DeleteIcon from "@mui/icons-material/Delete";
import { fetchServiceTypes } from "../../store/slices/serviceTypesSlice";
import { fetchRoles } from "../../store/slices/roleSlice";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { MdSearch } from "react-icons/md";
import { fetchEmployees } from "../../store/slices/employeeSlice";
import { useCurrencySymbol } from "../../utils/currencyUtils";
import { getFeatureAccessLevel } from "../../utils/featureAccessUtils";
const HourlyRatesManager = () => {
  const dispatch = useDispatch();
  const currency = useCurrencySymbol();
  const { quotations } = useSelector((state) => state.hourlyRateQuotation);
  const { serviceTypesRedux } = useSelector((state) => state.serviceTypesRedux);
  // const { roles } = useSelector((state) => state.roles);

  const { enqueueSnackbar } = useSnackbar();
  const [defaultOverheadPercentage, setDefaultOverheadPercentage] =
    useState("");
  const [useDefaultOverhead, setUseDefaultOverhead] = useState(false);
  const [isLoading, SetisLoading] = useState(false);
  const { employees } = useSelector((state) => state.employees);
  const email = localStorage.getItem("email");
  const [searchTerm, setSearchTerm] = useState("");

  const { items } = useSelector((state) => state.otherExpenses);

  const [rows, setRows] = useState([
    {
      id: 0,
      designation: "",
      hourlysalaray: "",
      overheadpercentage: "",
      personid: "",
    },
  ]);
  const dropdownRefs = useRef({});

  const [modifiedRows, setModifiedRows] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isexpenseModalOpen, setisexpenseModalOpen] = useState(false);

  const [_id, setRowToDelete] = useState(null);
  const [expenseID, setexpenseID] = useState(null);
  const [overheadPercentage, setOverheadPercentage] = useState(null);
  console.log("overheadPercentage", overheadPercentage);

  const [, setServiceCombination] = useState([]);
  // const [openDropdownId, setOpenDropdownId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  // const [selectedrowid, setselectedrowid] = useState("");
  const [openDropdownemployeeId, setopenDropdownemployeeId] = useState(null);
  const [isModal, setIsModal] = useState(false);
  const [index, setindex] = useState();

  const formatDesignationLabel = (designation = "") => {
    const raw = String(designation || "").trim();
    if (!raw) return "";
    const cleaned = raw
      .replace(/\bproject manager\b/gi, "Manager")
      .replace(/\boperations\b/gi, "Employee")
      .replace(/\s+/g, " ")
      .trim();
    return cleaned;
  };

  // Other Expenses state
  const [otherExpenseRows, setOtherExpenseRows] = useState([
    {
      description: "",
      cost: "",
      unit: "",
    },
  ]);
  // Sorting state
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  // const [expenseSortConfig, setExpenseSortConfig] = useState({
  //   key: null,
  //   direction: 'ascending'
  // });
  // const [expenseSearchQuery, setExpenseSearchQuery] = useState("");
  const userEmail = localStorage.getItem("email");
  const currentEmployee = employees.find((emp) => emp.EmpEmail === userEmail);

  const hasNoFeatureConfig = !currentEmployee?.featureAccess || currentEmployee.featureAccess.length === 0;
  const opsRatesLevel = getFeatureAccessLevel(currentEmployee, "OPERATIONS RATES HOURLY RATES & EXPENSES");
  const salesRatesLevel = getFeatureAccessLevel(currentEmployee, "SALES HOURLY RATES ADD HOURLY RATES");
  const ratesAccessLevel = opsRatesLevel || salesRatesLevel;
  const isViewOnly = !hasNoFeatureConfig && ratesAccessLevel &&
    String(ratesAccessLevel).trim().toUpperCase() === "VIEW ONLY";

  // In your useEffect that sets otherExpenseRows, ensure each row has a unique ID
  useEffect(() => {
    const matchedLead = employees.find(
      (employee) => employee.EmpEmail === email
    );
    const entries = items.filter((item) => item.createdBy === matchedLead?._id);

    // Add unique IDs to existing entries
    const entriesWithIds = entries.map((entry, index) => ({
      ...entry,
      id: entry._id || `existing-${index}`, // Use _id for existing, create unique for others
    }));

    setOtherExpenseRows(entriesWithIds);
  }, [items, employees, email]);

  const CustomRoles = useMemo(
    () => [
      {
        roleName: "project manager",
      },
      {
        roleName: "operations",
      },
    ],
    []
  );

  useEffect(() => {
    if (serviceTypesRedux && CustomRoles) {
      const filteredServiceTypes = serviceTypesRedux.filter(
        (serviceType) =>
          serviceType?.ServiceType === currentEmployee?.servicetype
      );
      const combinedData = filteredServiceTypes.flatMap((serviceType) => {
        return CustomRoles.map((role) => ({
          ...serviceType,
          ServiceType: `${serviceType.ServiceType} ${role.roleName}`,
        }));
      });
      setServiceCombination(combinedData);
    }
  }, [serviceTypesRedux, currentEmployee, CustomRoles]);

  // Load initial data
  useEffect(() => {
    const loadData = async () => {
      SetisLoading(true);
      try {
        await dispatch(fetchRoles());
        await dispatch(fetchServiceTypes());
        await dispatch(fetchQuotations());
        await dispatch(fetchOtherExpenses());
        await dispatch(fetchEmployees());
      } catch (error) {
        enqueueSnackbar("Failed to load data", { variant: "error" });
      } finally {
        SetisLoading(false);
      }
    };
    loadData();
    dispatch(setCurrentPageTitle("Hourly Rates & Expenses"));
  }, [dispatch, enqueueSnackbar]);

  useEffect(() => {
    if (!quotations || quotations.length === 0) {
      setDefaultOverheadPercentage("");
      return;
    }
    const userEmail = localStorage.getItem("email");
    const currentEmployee = employees.find((emp) => emp.EmpEmail === userEmail);
    if (!currentEmployee) {
      setDefaultOverheadPercentage("");
      return;
    }
    const filteredData = quotations.filter(
      (item) => item.createdBy === currentEmployee?._id
    );

    if (filteredData.length === 0) {
      setDefaultOverheadPercentage("");
      return;
    }

    const calculatedPercents = filteredData
      .map(({ hourlysalaray, overheadpercentage }) => {
        if (!hourlysalaray || hourlysalaray === 0 || !overheadpercentage)
          return null;
        const percent = Number(
          ((overheadpercentage / hourlysalaray) * 100).toFixed(2)
        );
        return isNaN(percent) ? null : percent;
      })
      .filter((v) => v !== null);

    if (calculatedPercents.length === 0) {
      setDefaultOverheadPercentage("");
      return;
    }

    const uniquePercents = [...new Set(calculatedPercents)];

    if (uniquePercents.length === 1) {
      setDefaultOverheadPercentage(uniquePercents[0]);
      setUseDefaultOverhead(true)
    } else {
      setDefaultOverheadPercentage("");
      setUseDefaultOverhead(false)
    }
  }, [quotations, employees]);

  // Load quotations into rows when they're available
  useEffect(() => {
    if (quotations && quotations.length > 0) {
      const userEmail = localStorage.getItem("email");
      const currentEmployee = employees.find(
        (emp) => emp.EmpEmail === userEmail
      );
      const filteredData = quotations.filter(
        (item) => item.createdBy === currentEmployee?._id
      );

      // ✅ Sort so that for each service type, Manager rows come before Operations rows
      const sortedData = [...filteredData].sort((a, b) => {
        const getServiceAndRole = (designation = "") => {
          let service = designation || "";
          let rolePriority = 2; // default

          const lower = designation.toLowerCase();

          if (lower.includes("manager")) {
            rolePriority = 0; // Manager first
            service = designation
              .replace(/project manager/i, "")
              .replace(/manager/i, "")
              .trim();
          } else if (lower.includes("operations")) {
            rolePriority = 1; // Operations after Manager
            service = designation.replace(/operations/i, "").trim();
          }

          return { service: service.toLowerCase(), rolePriority };
        };

        const aInfo = getServiceAndRole(a.designation || "");
        const bInfo = getServiceAndRole(b.designation || "");

        if (aInfo.service < bInfo.service) return -1;
        if (aInfo.service > bInfo.service) return 1;

        // Same service type → sort by role priority
        if (aInfo.rolePriority < bInfo.rolePriority) return -1;
        if (aInfo.rolePriority > bInfo.rolePriority) return 1;

        // Fallback: keep original order
        return 0;
      });

      const initialRows = sortedData.map((quote, index) => ({
        id: index,
        _id: quote._id,
        designation: quote.designation || "",
        hourlysalaray: quote.hourlysalaray
          ? quote.hourlysalaray.toString()
          : "",
        overheadpercentage: quote.overheadpercentage
          ? quote.overheadpercentage.toString()
          : "",
        personid: quote.personid || "",
      }));

      if (
        initialRows.length === 0 ||
        initialRows[initialRows.length - 1].designation
      ) {
        initialRows.push({
          id: initialRows.length,
          _id: null,
          designation: "",
          hourlysalaray: "",
          overheadpercentage: "",
          personid: "",
        });
      }

      setRows(initialRows);
    }
  }, [quotations, employees]);

  // Search input handler
  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Filter rows based on search query
  // const filteredRows = useMemo(() => {
  //   if (!searchQuery.trim()) return rows;

  //   const query = searchQuery.toLowerCase().trim();
  //   return rows.filter(row =>
  //     row.designation.toLowerCase().includes(query) ||
  //     (row.hourlysalaray && row.hourlysalaray.toString().includes(query)) ||
  //     (row.overheadpercentage && row.overheadpercentage.toString().includes(query))
  //   );
  // }, [rows, searchQuery]);
  const filteredRows = useMemo(() => {
    if (!searchQuery.trim()) return rows;

    const query = searchQuery.toLowerCase().trim();
    return rows.filter((row) => {
      // Existing search criteria
      const basicMatch =
        row.designation.toLowerCase().includes(query) ||
        (row.hourlysalaray && row.hourlysalaray.toString().includes(query)) ||
        (row.overheadpercentage &&
          row.overheadpercentage.toString().includes(query));

      // New: Search by employee name
      if (row.personid) {
        const employee = employees.find((emp) => emp._id === row.personid);
        if (employee) {
          const employeeName =
            `${employee.EmpFirstName} ${employee.EmpLastName}`.toLowerCase();
          const employeeMatch = employeeName.includes(query);
          return basicMatch || employeeMatch;
        }
      }

      return basicMatch;
    });
  }, [rows, searchQuery, employees]);

  // Sorting functions
  const handleSort = (key) => {
    let direction = "ascending";

    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
  };

  const sortRows = React.useCallback(
    (rowsToSort) => {
      if (!sortConfig.key) {
        // When no sort is active, put empty rows (no designation) at the bottom
        return [...rowsToSort].sort((a, b) => {
          const aHasDesignation = a.designation && a.designation.trim() !== "";
          const bHasDesignation = b.designation && b.designation.trim() !== "";
          
          if (aHasDesignation && !bHasDesignation) return -1;
          if (!aHasDesignation && bHasDesignation) return 1;
          return 0;
        });
      }

      return [...rowsToSort].sort((a, b) => {
        // Put rows without designation at top when ascending, at bottom when descending
        const aHasDesignation = a.designation && a.designation.trim() !== "";
        const bHasDesignation = b.designation && b.designation.trim() !== "";
        
        if (!aHasDesignation && bHasDesignation) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aHasDesignation && !bHasDesignation) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        
        // If both have designation or both don't, proceed with normal sorting
        // Employee sorting - by employee name
        if (sortConfig.key === "employee") {
          const getEmployeeName = (row) => {
            if (!row.personid) return "";
            const employee = employees.find((emp) => emp._id === row.personid);
            return employee
              ? `${employee.EmpFirstName} ${employee.EmpLastName}`.toLowerCase()
              : "";
          };

          const aValue = getEmployeeName(a);
          const bValue = getEmployeeName(b);

          if (aValue < bValue) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (aValue > bValue) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
          return 0;
        }

        // Existing sorting logic for other columns
        if (
          sortConfig.key === "hourlysalaray" ||
          sortConfig.key === "overheadpercentage"
        ) {
          const aValue = parseFloat(a[sortConfig.key]) || 0;
          const bValue = parseFloat(b[sortConfig.key]) || 0;

          if (aValue < bValue) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (aValue > bValue) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
          return 0;
        }

        if (sortConfig.key === "designation") {
          const aValue = a[sortConfig.key] || "";
          const bValue = b[sortConfig.key] || "";

          if (aValue.toLowerCase() < bValue.toLowerCase()) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (aValue.toLowerCase() > bValue.toLowerCase()) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
          return 0;
        }

        return 0;
      });
    },
    [sortConfig, employees]
  );

  const sortedRows = useMemo(() => {
    const filtered = filteredRows; // This already filters based on search
    return sortRows(filtered);
  }, [filteredRows, sortRows]);

  // const sortRows = (rowsToSort) => {
  //   if (!sortConfig.key) return rowsToSort;

  //   return [...rowsToSort].sort((a, b) => {
  //     if (sortConfig.key === 'hourlysalaray' || sortConfig.key === 'overheadpercentage') {
  //       const aValue = parseFloat(a[sortConfig.key]) || 0;
  //       const bValue = parseFloat(b[sortConfig.key]) || 0;

  //       if (aValue < bValue) {
  //         return sortConfig.direction === 'ascending' ? -1 : 1;
  //       }
  //       if (aValue > bValue) {
  //         return sortConfig.direction === 'ascending' ? 1 : -1;
  //       }
  //       return 0;
  //     }

  //     if (sortConfig.key === 'designation') {
  //       const aValue = a[sortConfig.key] || '';
  //       const bValue = b[sortConfig.key] || '';

  //       if (aValue.toLowerCase() < bValue.toLowerCase()) {
  //         return sortConfig.direction === 'ascending' ? -1 : 1;
  //       }
  //       if (aValue.toLowerCase() > bValue.toLowerCase()) {
  //         return sortConfig.direction === 'ascending' ? 1 : -1;
  //       }
  //       return 0;
  //     }

  //     return 0;
  //   });
  // };

  // Other Expenses functions
  // const handleAddOtherExpenseRow = () => {
  //   const newId = Date.now(); // Use timestamp for unique IDs

  //   setOtherExpenseRows([
  //     ...otherExpenseRows,
  //     {
  //       id: newId,
  //       description: "",
  //       cost: "",
  //       unit: "",
  //     },
  //   ]);
  // };

  // const handleRemoveOtherExpenseRow = () => {
  //   if (otherExpenseRows.length > 1) {
  //     setOtherExpenseRows(otherExpenseRows.slice(0, -1));
  //   } else {
  //     enqueueSnackbar("At least one row is required", { variant: "error" });
  //   }
  // };

  // const handleOtherExpenseInputChange = (e, rowId, field) => {
  //   const value = e.target.value;

  //   if (field === "cost" && value !== "" && isNaN(value)) {
  //     return;
  //   }

  //   setOtherExpenseRows(prevRows =>
  //     prevRows.map(row => {
  //       if (row.id !== rowId) return row;
  //       return { ...row, [field]: value };
  //     })
  //   );
  // };

  const handleAddRow = () => {
    if (isViewOnly) return;
    const newId =
      rows.length > 0 ? Math.max(...rows.map((row) => row.id)) + 1 : 0;
    setRows([
      ...rows,
      {
        id: newId,
        designation: "",
        hourlysalaray: "",
        overheadpercentage: "",
        personid: "",
      },
    ]);
  };

  // const handleRemoveRow = () => {
  //   if (!selectedrowid) {
  //     enqueueSnackbar("Please Select Row To Delete", { variant: "error" });
  //     return
  //   }
  //   handleDeleteRow(selectedrowid)
  // };

  const handleInputChange = (e, rowId, field) => {
    if (isViewOnly) return;
    const value = e.target.value;

    if (
      (field === "overheadpercentage" || field === "hourlysalaray") &&
      value !== "" &&
      isNaN(value)
    ) {
      return;
    }

    // Clear sort when editing to prevent rows from reordering
    if (field === "hourlysalaray" || field === "overheadpercentage") {
      if (sortConfig.key === field) {
        setSortConfig({ key: null, direction: "ascending" });
      }
    }

    setRows((prevRows) => {
      const updatedRows = prevRows.map((row) => {
        if (row.id !== rowId) return row;

        const updatedRow = { ...row, [field]: value };

        if (
          field === "hourlysalaray" &&
          useDefaultOverhead &&
          value !== "" &&
          !isNaN(value)
        ) {
          const overheadValue = (
            (parseFloat(value) * parseFloat(defaultOverheadPercentage || 0)) /
            100
          ).toFixed(2);
          updatedRow.overheadpercentage = overheadValue;
        }

        if (row._id) {
          const originalRow = quotations.find((q) => q._id === row._id);
          if (originalRow) {
            const isModified =
              (field === "designation" && value !== originalRow.designation) ||
              (field === "hourlysalaray" &&
                parseFloat(value || 0) !== originalRow.hourlysalaray) ||
              (field === "overheadpercentage" &&
                parseFloat(value || 0) !== originalRow.overheadpercentage);

            if (isModified) {
              setModifiedRows((prev) => {
                const filtered = prev.filter((r) => r._id !== row._id);
                return [...filtered, updatedRow];
              });
            }
          }
        }

        return updatedRow;
      });

      // Check if all overhead percentages are the same after update
      if (field === "overheadpercentage" || field === "hourlysalaray") {
        const calculatedPercents = updatedRows
          .map(({ hourlysalaray, overheadpercentage }) => {
            if (!hourlysalaray || !overheadpercentage) return null;
            const hourlyValue = parseFloat(
              hourlysalaray.toString().replace(/,/g, "")
            );
            const overheadValue = parseFloat(
              overheadpercentage.toString().replace(/,/g, "")
            );
            if (!hourlyValue || isNaN(hourlyValue) || isNaN(overheadValue))
              return null;
            return Number(((overheadValue / hourlyValue) * 100).toFixed(2));
          })
          .filter((v) => v !== null);

        const uniquePercents = [...new Set(calculatedPercents)];

        if (uniquePercents.length === 1 && calculatedPercents.length > 0) {
          // All percentages are the same, keep the default
          setDefaultOverheadPercentage(uniquePercents[0]);
        } else if (calculatedPercents.length > 0) {
          // Different percentages, clear the default
          setDefaultOverheadPercentage("");
        }
      }

      return updatedRows;
    });
  };

  // const handleSaveOtherExpenses = async () => {

  //   // Validation: Check if all required fields are filled
  //   // const invalidEntries = otherExpenseRows.filter(row => {
  //   //   return !row.description?.trim() || !row.unit || !row.cost;
  //   // });

  //   // if (invalidEntries.length > 0) {
  //   //   enqueueSnackbar("Please fill all required fields (description, unit, cost) for all entries", {
  //   //     variant: "error"
  //   //   });
  //   //   return;
  //   // }

  //   const payload = {
  //     expenses: otherExpenseRows
  //   };

  //   try {
  //     SetisLoading(true);
  //     await dispatch(createOtherExpense(payload));
  //     enqueueSnackbar("Other Expenses saved successfully", { variant: "success" });
  //   } catch (error) {
  //     enqueueSnackbar("Failed to save Other Expenses", { variant: "error" });
  //   } finally {
  //     SetisLoading(false);
  //   }
  // };

  const handleSaveOtherExpenses = async () => {
    // Validation: Check if all required fields are filled
    // const invalidEntries = otherExpenseRows.filter(row => {
    //   return !row.description?.trim() || !row.unit || !row.cost;
    // });

    // if (invalidEntries.length > 0) {
    //   enqueueSnackbar("Please fill all required fields (description, unit, cost) for all entries", {
    //     variant: "error"
    //   });
    //   return;
    // }
    // Normalize: convert cost & unit to numbers (if possible)
    const normalizedRows = otherExpenseRows.map((row) => ({
      ...row,
      cost:
        row.cost !== undefined && !isNaN(row.cost)
          ? Number(row.cost)
          : row.cost,
      unit:
        row.unit !== undefined && !isNaN(row.unit)
          ? Number(row.unit)
          : row.unit,
    }));

    const payload = {
      expenses: normalizedRows,
    };

    try {
      SetisLoading(true);
      await dispatch(createOtherExpense(payload));
      // enqueueSnackbar("Other Expenses saved successfully", { variant: "success" });
    } catch (error) {
      enqueueSnackbar("Failed to save Other Expenses", { variant: "error" });
    } finally {
      SetisLoading(false);
    }
  };

  const handleSavehour = async () => {
    const rowsWithData = rows.filter(
      (row) =>
        row.designation.trim() !== "" &&
        row.hourlysalaray !== "" &&
        row.personid !== ""
    );

    const hasInvalidFields = rowsWithData.some((row) => {
      return (
        isNaN(parseFloat(row.hourlysalaray)) ||
        parseFloat(row.hourlysalaray) < 0
      );
    });

    if (hasInvalidFields) {
      enqueueSnackbar("Please fill all fields with valid values", {
        variant: "error",
      });
      return;
    }

    SetisLoading(true);

    try {
      if (modifiedRows.length > 0) {
        const updatePayload = modifiedRows.map((row) => ({
          _id: row._id,
          designation: row.designation.trim(),
          hourlysalaray: parseFloat(row.hourlysalaray),
          overheadpercentage: parseFloat(row.overheadpercentage),
          personid: row.personid,
        }));

        await dispatch(updateQuotation({ quotations: updatePayload })).unwrap();
      }

      const newRows = rowsWithData.filter((row) => !row._id);
      if (newRows.length > 0) {
        const createPayload = newRows.map((row) => ({
          designation: row.designation.trim(),
          hourlysalaray: parseFloat(row.hourlysalaray),
          overheadpercentage: parseFloat(row.overheadpercentage),
          personid: row.personid,
        }));

        await dispatch(createQuotation({ quotations: createPayload })).unwrap();
      }

      // if (modifiedRows.length > 0 || newRows.length > 0) {
      //   enqueueSnackbar("Hourly Rates saved successfully!", {
      //     variant: "success",
      //   });
      // }

      await dispatch(fetchQuotations()).unwrap();
      setModifiedRows([]);

      // Force recalculation of default overhead percentage after save
      // The useEffect will handle this, but we ensure it triggers
    } catch (error) {
      enqueueSnackbar(error.message || "Failed to save quotation", {
        variant: "error",
      });
    } finally {
      SetisLoading(false);
    }
  };

  const handleSaveExpense = async () => {
    if (isViewOnly) return;
    try {
      await handleSavehour();
      await handleSaveOtherExpenses();
      enqueueSnackbar("Rates and Expenses saved successfully!", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar(error.message || "Failed to save quotation", {
        variant: "error",
      });
    } finally {
      SetisLoading(false);
      dispatch(fetchOtherExpenses());
    }
  };

  const handleDeleteRow = (id, index) => {
    if (isViewOnly) return;
    setindex(index);
    if (id) {
      setRowToDelete(id);
      setIsModalOpen(true);
    } else {
      setIsModal(true);
    }
  };

  // const handleexpenseDeleteRow = (id) => {
  //   setexpenseID(id);
  //   setisexpenseModalOpen(true);
  // };

  const confirmDelete = async () => {
    SetisLoading(true);
    try {
      await dispatch(deleteQuotation(_id));
      enqueueSnackbar("Row  Deleted Successfully!", {
        variant: "success",
      });
    } catch (error) {
      console.error("Failed to create task:", error);
    } finally {
      SetisLoading(false);
      // setOpenDropdownId(null);
      setRowToDelete(null);
      setIsModalOpen(false);
      dispatch(fetchQuotations());
      dispatch(fetchOtherExpenses());
    }
  };

  const confirmExpenseDelete = async () => {
    SetisLoading(true);
    try {
      await dispatch(deleteOtherExpense(expenseID));
      enqueueSnackbar("Row  Deleted Successfully!", {
        variant: "success",
      });
    } catch (error) {
      console.error("Failed to create task:", error);
    } finally {
      SetisLoading(false);
      // setOpenDropdownId(null);
      setexpenseID(null);
      setisexpenseModalOpen(false);
      dispatch(fetchQuotations());
      dispatch(fetchOtherExpenses());
    }
  };

  // const toggleDropdown = (rowId) => {
  //   setOpenDropdownId(openDropdownId === rowId ? null : rowId);
  // };

  const toggleDropdownemployee = (rowId) => {
    setopenDropdownemployeeId(openDropdownemployeeId === rowId ? null : rowId);
  };

  // const handleExpenseSearchInputChange = (e) => {
  //   setExpenseSearchQuery(e.target.value);
  // };

  // const handleExpenseSort = (key) => {
  //   let direction = 'ascending';

  //   if (expenseSortConfig.key === key && expenseSortConfig.direction === 'ascending') {
  //     direction = 'descending';
  //   }

  //   setExpenseSortConfig({ key, direction });
  // };

  // const sortExpenseRows = React.useCallback((rowsToSort) => {
  //   if (!expenseSortConfig.key) return rowsToSort;

  //   return [...rowsToSort].sort((a, b) => {
  //     if (expenseSortConfig.key === 'cost' || expenseSortConfig.key === 'unit') {
  //       const aValue = parseFloat(a[expenseSortConfig.key]) || 0;
  //       const bValue = parseFloat(b[expenseSortConfig.key]) || 0;

  //       if (aValue < bValue) {
  //         return expenseSortConfig.direction === 'ascending' ? -1 : 1;
  //       }
  //       if (aValue > bValue) {
  //         return expenseSortConfig.direction === 'ascending' ? 1 : -1;
  //       }
  //       return 0;
  //     }

  //     if (expenseSortConfig.key === 'description') {
  //       const aValue = a[expenseSortConfig.key] || '';
  //       const bValue = b[expenseSortConfig.key] || '';

  //       if (aValue.toLowerCase() < bValue.toLowerCase()) {
  //         return expenseSortConfig.direction === 'ascending' ? -1 : 1;
  //       }
  //       if (aValue.toLowerCase() > bValue.toLowerCase()) {
  //         return expenseSortConfig.direction === 'ascending' ? 1 : -1;
  //       }
  //       return 0;
  //     }

  //     return 0;
  //   });
  // }, [expenseSortConfig]);

  // Add this useMemo to filter and sort expense rows
  // const filteredExpenseRows = useMemo(() => {
  //   let filtered = otherExpenseRows;

  //   if (expenseSearchQuery.trim()) {
  //     const query = expenseSearchQuery.toLowerCase().trim();
  //     filtered = otherExpenseRows.filter(row =>
  //       row.description.toLowerCase().includes(query) ||
  //       (row.cost && row.cost.toString().includes(query)) ||
  //       (row.unit && row.unit.toString().includes(query))
  //     );
  //   }

  //   return sortExpenseRows(filtered);
  // }, [otherExpenseRows, expenseSearchQuery, sortExpenseRows]);

  // const hasAvailableEmployees = employees?.some(employee => {
  //   if (!employee.servicetype) return false;

  //   // Identify manager for logged-in user (if exists)
  //   const manager = employees.find(
  //     emp =>
  //       emp.customRoles?.includes("project manager") &&
  //       emp.EmpEmail === email
  //   );

  //   // If logged-in user is not a project manager → just check that there are employees with servicetype
  //   if (!manager) return true;

  //   // Collect all personids already selected
  //   const selectedPersonIds = rows.filter(r => r.personid).map(r => r.personid);

  //   // Skip already assigned employees
  //   if (selectedPersonIds.includes(employee._id)) return false;

  //   // ✅ Allow manager if not assigned yet
  //   if (employee._id === manager._id)
  //     return !selectedPersonIds.includes(manager._id);

  //   // ✅ Allow operations employees with same servicetype as manager
  //   if (
  //     employee.customRoles?.includes("operations") &&
  //     employee.servicetype === manager.servicetype
  //   )
  //     return true;

  //   return false;
  // });

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if dropdown is open and clicked element is NOT inside it
      if (openDropdownemployeeId !== null) {
        const openDropdownRef =
          dropdownRefs.current[`dropdown-${openDropdownemployeeId}`];
        if (openDropdownRef && !openDropdownRef.contains(event.target)) {
          setopenDropdownemployeeId(null); // Close the dropdown
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openDropdownemployeeId]);

  const applyDefaultOverheadToRows = (percentage) => {
    if (isViewOnly) return;
    setRows((prevRows) => {
      const updatedRows = prevRows.map((row) => {
        if (!row.hourlysalaray || isNaN(row.hourlysalaray)) return row;

        const hourlysalarayValue =
          typeof row.hourlysalaray === "string"
            ? parseFloat(row.hourlysalaray.replace(/,/g, ""))
            : parseFloat(row.hourlysalaray);
        const head = percentage || 10;
        const overhead = (
          (hourlysalarayValue * parseFloat(head)) /
          100
        ).toFixed(2);

        const updatedRow = {
          ...row,
          overheadpercentage: overhead,
        };

        // If this row has an _id (existing row), mark it as modified
        if (row._id) {
          const originalRow = quotations.find((q) => q._id === row._id);
          if (originalRow) {
            const isModified =
              parseFloat(overhead) !== originalRow.overheadpercentage;

            if (isModified) {
              setModifiedRows((prevModified) => {
                const filtered = prevModified.filter((r) => r._id !== row._id);
                return [...filtered, updatedRow];
              });
            }
          }
        }

        return updatedRow;
      });

      return updatedRows;
    });
  };

  return (
    <>
      {isLoading ? <AdminLoader isLoading={isLoading} /> : <></>}
      <>
        <div className="pt-6">
          <div className="mr-4 p-4  bg-white rounded-md border border-gray-200 shadow-lg">
            <div className="flex justify-between py-1 align-middle items-center pr-8">
              <h1 className="text-xl mb-2 font-semibold">Add Hourly Rates</h1>

              <div className="flex gap-2 p-1 align-middle items-center bg-[#e0e7ff] rounded-full">
                <MdSearch className=" w-5 h-5 text-gray-500" />
                <input
                  type="text"
                  value={searchQuery}
                  onChange={handleSearchInputChange}
                  placeholder="Search"
                  className="bg-[#e0e7ff] outline-none w-[80%]"
                />
              </div>
            </div>
            <div className="px-[2rem] w-full">
              <div className="relative parent w-full text-xs">
                {/* Fixed Header */}
                <div
                  style={{ zIndex: 1000 }}
                  className="w-full sticky top-0 left-0  bg-[#e8e8e8]"
                >
                  <div className="flex w-full">
                    <div className="w-[25%] relative flex justify-between align-middle items-center font-semibold p-2 ">
                      Employee
                      <div className="flex absolute right-2  flex-col">
                        <div
                          className="cursor-pointer"
                          onClick={() => handleSort("employee")}
                        >
                          <ArrowDropUp
                            sx={{
                              fontSize: "22px",
                            }}
                          />
                        </div>
                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() => handleSort("employee")}
                        >
                          <ArrowDropDown
                            sx={{
                              fontSize: "22px",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="w-[25%] relative flex justify-between align-middle items-center  font-semibold p-2">
                      Designation
                      <div className="flex absolute right-2  flex-col">
                        <div
                          className="cursor-pointer"
                          onClick={() => handleSort("designation")}
                        >
                          <ArrowDropUp
                            sx={{
                              fontSize: "22px",
                            }}
                          />
                        </div>
                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() => handleSort("designation")}
                        >
                          <ArrowDropDown
                            sx={{
                              fontSize: "22px",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="w-[25%] relative flex justify-center align-middle items-center font-semibold p-2 ">
                      Hourly Salary ({currency})
                      <div className="flex absolute right-2  flex-col">
                        <div
                          className="cursor-pointer"
                          onClick={() => handleSort("hourlysalaray")}
                        >
                          <ArrowDropUp
                            sx={{
                              fontSize: "22px",
                            }}
                          />
                        </div>
                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() => handleSort("hourlysalaray")}
                        >
                          <ArrowDropDown
                            sx={{
                              fontSize: "22px",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="w-[25%] relative font-semibold p-2 flex gap-2 justify-center items-center bg-[#e8e8e8]">
                      <div className="flex items-center gap-2 flex-wrap">
                        <span className="whitespace-nowrap">
                          Overhead ({currency})
                        </span>
                        <div className="flex gap-0.5 align-middle items-center">
                          (
                          <div className="flex items-center gap-1 rounded-md ">
                            <input
                              type="number"
                              value={defaultOverheadPercentage}
                              disabled={isViewOnly}
                              onChange={(e) => {
                                if (isViewOnly) return;
                                const value = e.target.value;
                                setUseDefaultOverhead(false);

                                if (value === "") {
                                  setDefaultOverheadPercentage(value);
                                  return;
                                }

                                const numValue = parseFloat(value);

                                if (
                                  !isNaN(numValue) &&
                                  numValue >= 0 &&
                                  numValue <= 100
                                ) {
                                  setDefaultOverheadPercentage(value);
                                }
                              }}
                              placeholder="10"
                              className={`w-6 text-center border outline-none rounded px-1 py-0.5 ${isViewOnly
                                ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed"
                                : "bg-white focus:ring-1 focus:ring-blue-400"
                              }`}
                              min="0"
                              max="100"
                            />
                            <span className="text-gray-600 text-sm">%</span>
                            <div className="relative inline-flex items-center justify-center ml-1">
                              <input
                                type="checkbox"
                                checked={useDefaultOverhead}
                                onChange={async (e) => {
                                  if (isViewOnly) return;
                                  const isChecked = e.target.checked;
                                  setUseDefaultOverhead(isChecked);

                                  if (isChecked) {
                                    applyDefaultOverheadToRows(
                                      defaultOverheadPercentage
                                    );

                                    setOverheadPercentage(
                                      defaultOverheadPercentage
                                    );

                                    enqueueSnackbar(
                                      "Default overhead percentage applied",
                                      { variant: "success" }
                                    );
                                  } else {
                                    setDefaultOverheadPercentage("");
                                    setOverheadPercentage(null);
                                  }
                                }}
                                className={`h-4 w-4 rounded border-2 appearance-none
                                transition-colors duration-200 focus:ring-2 focus:ring-blue-500
                                ${isViewOnly
                                    ? "cursor-not-allowed opacity-60"
                                    : "cursor-pointer"
                                }
                                ${useDefaultOverhead
                                    ? "bg-yellow-400 border-yellow-500"
                                    : "bg-white border-gray-300"
                                  }`}
                                disabled={isViewOnly || isLoading}
                              />
                              {useDefaultOverhead && (
                                <svg
                                  className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 h-3 w-3 text-gray-800 pointer-events-none"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={3}
                                    d="M5 13l4 4L19 7"
                                  />
                                </svg>
                              )}
                            </div>
                          </div>
                          )
                        </div>
                      </div>

                      <div className="flex absolute right-2 flex-col">
                        <div
                          className="cursor-pointer hover:bg-gray-200 rounded transition-colors"
                          onClick={() => handleSort("overheadpercentage")}
                        >
                          <ArrowDropUp
                            sx={{
                              fontSize: "22px",
                            }}
                          />
                        </div>
                        <div
                          className="cursor-pointer -mt-2 hover:bg-gray-200 rounded transition-colors"
                          onClick={() => handleSort("overheadpercentage")}
                        >
                          <ArrowDropDown
                            sx={{
                              fontSize: "22px",
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="w-[4%] flex gap-1 justify-center align-middle items-center ">
                      <div className="py-1 flex justify-center align-middle items-center text-md">
                        <DeleteIcon className="deleteicon cursor-pointer " />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Content with padding to account for fixed header */}
                <div className="w-full">
                  <div className="Grouplist w-full">
                    <div className="hourlyrate">
                      {sortedRows?.length > 0 ? (
                        sortedRows.map((row, index) => (
                          <div
                            key={index}
                            className="mainrow relative group flex w-full transition-colors duration-200"
                          >
                            <div className="w-[25%] p-1 border-b border-l flex justify-start align-middle items-center">
                              {row.personid && row._id ? (
                                (() => {
                                  // Find the selected employee by personid
                                  const selectedEmployee = employees.find(
                                    (emp) => emp._id === row.personid
                                  );
                                  return selectedEmployee
                                    ? `${selectedEmployee.EmpFirstName} ${selectedEmployee.EmpLastName}`
                                    : "Select Designation";
                                })()
                              ) : (
                                <div className="relative servicedropdown flex p-0 rounded-xl align-middle items-center w-full">
                                  <ExpandMoreIcon
                                    onClick={() => {
                                      if (isViewOnly) return;
                                      toggleDropdownemployee(row.id);
                                    }}
                                    className={`absolute right-2 m-auto ${isViewOnly
                                      ? "text-[#9ca3af] cursor-not-allowed"
                                      : "cursor-pointer text-black"
                                    }`}
                                  />
                                  <button
                                    type="button"
                                    disabled={isViewOnly}
                                    onClick={() => {
                                      if (isViewOnly) return;
                                      toggleDropdownemployee(row.id);
                                    }}
                                    className={`border w-full border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none ${isViewOnly
                                      ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed"
                                      : "text-black"
                                    }`}
                                  >
                                    <span>
                                      {row.personid
                                        ? (() => {
                                          // Find the selected employee by personid
                                          const selectedEmployee =
                                            employees.find(
                                              (emp) =>
                                                emp._id === row.personid
                                            );
                                          return selectedEmployee
                                            ? `${selectedEmployee.EmpFirstName} ${selectedEmployee.EmpLastName}`
                                            : "Select Designation";
                                        })()
                                        : "Select Designation"}
                                    </span>
                                  </button>
                                  {openDropdownemployeeId === row.id && (
                                    <div
                                      ref={(el) =>
                                      (dropdownRefs.current[
                                        `dropdown-${row.id}`
                                      ] = el)
                                      }
                                      style={{ zIndex: 999 }}
                                      className="Designationdropdown absolute top-full left-0 w-full p-1 cursor-pointer text-black bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                                    >
                                      {/* 🔍 Search Input */}
                                      <div className="p-2 flex justify-center items-center">
                                        <input
                                          type="text"
                                          placeholder="Search employee"
                                          className="w-full h-full border border-gray-300 rounded-md px-2 py-1 focus:outline-none focus:ring-1 focus:ring-blue-500"
                                          value={searchTerm || ""}
                                          onChange={(e) =>
                                            setSearchTerm(
                                              e.target.value.toLowerCase()
                                            )
                                          }
                                        />
                                      </div>
                                      <div className="max-h-96 overflow-y-auto capitalize">
                                        {(() => {
                                          const filteredEmployees = employees
                                            .filter((employee) => {
                                              if (!employee.servicetype)
                                                return false;

                                              // Find the project manager for the logged-in user
                                              const manager = employees.find(
                                                (emp) =>
                                                  emp.customRoles?.includes(
                                                    "project manager"
                                                  ) && emp.EmpEmail === email
                                              );
                                              if (!manager) return false;

                                              // Collect all personids already selected in other rows
                                              const otherRowPersonIds = rows
                                                .filter(
                                                  (r) =>
                                                    r.id !== row.id &&
                                                    r.personid
                                                )
                                                .map((r) => r.personid);

                                              // ❌ Skip already assigned employees from other rows
                                              if (
                                                otherRowPersonIds.includes(
                                                  employee._id
                                                )
                                              )
                                                return false;

                                              // ❌ Skip the currently selected employee for this row
                                              if (employee._id === row.personid)
                                                return false;

                                              // Include project manager once
                                              if (employee._id === manager._id)
                                                return !otherRowPersonIds.includes(
                                                  manager._id
                                                );

                                              // Include operations matching servicetype
                                              if (
                                                employee.customRoles?.includes(
                                                  "operations"
                                                ) &&
                                                employee.servicetype ===
                                                manager.servicetype
                                              ) {
                                                return true;
                                              }

                                              return false;
                                            })
                                            // 🧠 Advanced multi-term search
                                            .filter((employee) => {
                                              if (!searchTerm) return true;

                                              const tokens = searchTerm
                                                .split(" ")
                                                .map((t) => t.trim())
                                                .filter(Boolean);

                                              // Create a single searchable string
                                              const searchable = [
                                                employee.EmpFirstName,
                                                employee.EmpLastName,
                                                employee.servicetype,
                                                ...(employee.customRoles || []),
                                              ]
                                                .join(" ")
                                                .toLowerCase();

                                              // ✅ Match only if all tokens exist somewhere in the string
                                              return tokens.every((token) =>
                                                searchable.includes(token)
                                              );
                                            });

                                          if (filteredEmployees.length === 0) {
                                            return (
                                              <div className="p-3 text-center text-gray-500 ">
                                                {searchTerm
                                                  ? "No employees found"
                                                  : "No available employees"}
                                              </div>
                                            );
                                          }

                                          return filteredEmployees.map(
                                            (employee) => (
                                              <div
                                                key={employee._id}
                                                className="p-1 hover:bg-gray-200"
                                                onClick={() => {
                                                  const designationParts = [];
                                                  if (employee.servicetype)
                                                    designationParts.push(
                                                      employee.servicetype
                                                    );
                                                  if (
                                                    employee.customRoles
                                                      ?.length > 0
                                                  )
                                                    designationParts.push(
                                                      employee.customRoles.join(
                                                        ", "
                                                      )
                                                    );
                                                  const designation =
                                                    designationParts.join(" ");

                                                  const updatedRows = rows.map(
                                                    (r) =>
                                                      r.id === row.id
                                                        ? {
                                                          ...r,
                                                          designation,
                                                          personid:
                                                            employee._id,
                                                        }
                                                        : r
                                                  );

                                                  setRows(updatedRows);
                                                  setopenDropdownemployeeId(
                                                    null
                                                  );
                                                  setSearchTerm("");
                                                }}
                                              >
                                                <span className="font-semibold">
                                                  {employee.EmpFirstName}{" "}
                                                  {employee.EmpLastName}
                                                </span>
                                                <br />
                                                <span className="text-xs text-gray-500">
                                                  ({employee.servicetype}
                                                  {employee.customRoles
                                                    ?.length > 0 &&
                                                    ` ${employee.customRoles.join(
                                                      ", "
                                                    )}`}
                                                  )
                                                </span>
                                              </div>
                                            )
                                          );
                                        })()}
                                      </div>
                                    </div>
                                  )}
                                  {/* {openDropdownemployeeId === row.id && (
                                      <div
                                        ref={(el) => (dropdownRefs.current[`dropdown-${row.id}`] = el)}
                                        style={{ zIndex: 999 }}
                                        className="Designationdropdown absolute top-full left-0 w-full p-1 cursor-pointer text-black bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                                      >
                                        <div className="p-2 flex justify-center items-center">
                                          <input
                                            type="text"
                                            placeholder="Search employee"
                                            className="w-full h-full border border-gray-300 rounded-md px-2 py-1 focus:outline-none focus:ring-1 focus:ring-blue-500"
                                            value={searchTerm || ""}
                                            onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
                                          />
                                        </div>
                                        <div className="max-h-96 overflow-y-auto capitalize">
                                          {employees
                                            .filter((employee) => {
                                              if (!employee.servicetype) return false;

                                              const manager = employees.find(
                                                (emp) =>
                                                  emp.customRoles?.includes("project manager") &&
                                                  emp.EmpEmail === email
                                              );
                                              if (!manager) return false;

                                              const otherRowPersonIds = rows
                                                .filter((r) => r.id !== row.id && r.personid)
                                                .map((r) => r.personid);

                                              if (otherRowPersonIds.includes(employee._id)) return false;

                                              if (employee._id === row.personid) return false;

                                              if (employee._id === manager._id)
                                                return !otherRowPersonIds.includes(manager._id);

                                              if (
                                                employee.customRoles?.includes("operations") &&
                                                employee.servicetype === manager.servicetype
                                              ) {
                                                return true;
                                              }

                                              return false;
                                            })
                                            .filter((employee) => {
                                              if (!searchTerm) return true;

                                              const tokens = searchTerm
                                                .split(" ")
                                                .map((t) => t.trim())
                                                .filter(Boolean);

                                              const searchable = [
                                                employee.EmpFirstName,
                                                employee.EmpLastName,
                                                employee.servicetype,
                                                ...(employee.customRoles || []),
                                              ]
                                                .join(" ")
                                                .toLowerCase();

                                              return tokens.every((token) => searchable.includes(token));
                                            })
                                            .map((employee) => (
                                              <div
                                                key={employee._id}
                                                className="p-1 hover:bg-gray-200"
                                                onClick={() => {
                                                  const designationParts = [];
                                                  if (employee.servicetype) designationParts.push(employee.servicetype);
                                                  if (employee.customRoles?.length > 0)
                                                    designationParts.push(employee.customRoles.join(", "));
                                                  const designation = designationParts.join(" ");

                                                  const updatedRows = rows.map((r) =>
                                                    r.id === row.id
                                                      ? { ...r, designation, personid: employee._id }
                                                      : r
                                                  );

                                                  setRows(updatedRows);
                                                  setopenDropdownemployeeId(null);
                                                  setSearchTerm("");
                                                }}
                                              >
                                                <span className="font-semibold">
                                                  {employee.EmpFirstName} {employee.EmpLastName}
                                                </span>
                                                <br />
                                                <span className="text-xs text-gray-500">
                                                  ({employee.servicetype}
                                                  {employee.customRoles?.length > 0 &&
                                                    ` ${employee.customRoles.join(", ")}`}
                                                  )
                                                </span>
                                              </div>
                                            ))}
                                        </div>
                                      </div>
                                    )} */}
                                </div>
                              )}
                            </div>

                            <div className="w-[25%]  p-1 border-b flex justify-start align-middle items-center ">
                              {formatDesignationLabel(row.designation)}
                            </div>

                            <div className="w-[25%] flex gap-1 justify-center align-middle items-center p-1 border-b">
                              <input
                                type="text"
                                value={row.hourlysalaray}
                                disabled={isViewOnly}
                                onChange={(e) => {
                                  if (isViewOnly) return;
                                  let value = e.target.value;

                                  if (
                                    /^\d*\.?\d{0,3}$/.test(value) ||
                                    value === ""
                                  ) {
                                    handleInputChange(
                                      {
                                        ...e,
                                        target: { ...e.target, value },
                                      },
                                      row.id,
                                      "hourlysalaray"
                                    );
                                  }
                                }}
                                placeholder="Enter Hourly Salary"
                                className={`w-1/2 p-2 outline-none rounded text-center ${isViewOnly
                                  ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed"
                                  : !row.designation || row.designation.trim() === "" || row.designation.includes("Hardware")
                                    ? "bg-transparent text-black"
                                    : "bg-[#e8e8e8] text-black"
                                }`}
                              />
                            </div>

                            <div className="w-[25%] flex gap-1 justify-center align-middle items-center pr-2 p-1 border-b">
                              <input
                                type="text"
                                value={row.overheadpercentage}
                                disabled={isViewOnly}
                                onChange={(e) => {
                                  if (isViewOnly) return;
                                  let value = e.target.value;

                                  if (
                                    /^\d*\.?\d{0,3}$/.test(value) ||
                                    value === ""
                                  ) {
                                    handleInputChange(
                                      {
                                        ...e,
                                        target: { ...e.target, value },
                                      },
                                      row.id,
                                      "overheadpercentage"
                                    );
                                  }
                                }}
                                placeholder="Enter Overhead"
                                className={`w-1/2 p-2 outline-none rounded text-center ${isViewOnly
                                  ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed"
                                  : !row.designation || row.designation.trim() === "" || row.designation.includes("Hardware")
                                    ? "bg-transparent text-black"
                                    : "bg-[#e8e8e8] text-black"
                                }`}
                              />
                            </div>

                            <div className="w-[4%] flex gap-1 justify-center align-middle items-center pr-2 p-1 border-b border-r">
                              <div className={`deleteicondiv py-1 flex justify-center align-middle items-center text-md ${isViewOnly ? "opacity-60" : "opacity-0 group-hover:opacity-100"} transition-opacity duration-200`}>
                                <DeleteIcon
                                  className={`deleteicon ${isViewOnly
                                    ? "text-[#9ca3af] cursor-not-allowed pointer-events-none"
                                    : "cursor-pointer text-[#df3b3b] hover:text-[#c12a2a]"
                                  }`}
                                  onClick={() => {
                                    if (isViewOnly) return;
                                    handleDeleteRow(row._id, index);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="w-full text-center text-red-600 py-4">
                          No Data Present
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex px-[2rem] justify-start items-center w-full  mt-2 mb-4">
              {/* {hasAvailableEmployees && ( */}
              <div className={`rounded-md p-1 shadow-lg border flex justify-center items-center ${isViewOnly ? "bg-[#e5e7eb]" : "bg-white"}`}>
                <AddIcon
                  onClick={handleAddRow}
                  className={isViewOnly
                    ? "text-[#9ca3af] cursor-not-allowed pointer-events-none opacity-60"
                    : "cursor-pointer text-black"
                  }
                />
              </div>
              {/* )} */}
            </div>

            {/* <div className="OtherExpensesBlock pt-10">
              <h1 className="text-2xl mb-2 font-semibold">Other Expenses</h1>
              <div className="flex justify-between align-middle items-center py-2 pr-8">
                <h3 className=" font-semibold">
                  Installation Crew per person
                </h3>
                <div className="flex gap-2 p-1 align-middle items-center bg-[#e0e7ff] rounded-full">
                  <MdSearch className=" w-5 h-5 text-gray-500" />
                  <input
                    type="text"
                    value={expenseSearchQuery}
                    onChange={handleExpenseSearchInputChange}
                    placeholder="Search Other Expenses"
                    className="bg-[#e0e7ff] outline-none w-[80%]"
                  />
                </div>
              </div>

              <div className="Otherbox w-full px-[2rem]">
                <div className="flex w-full">
                  <div className="w-[50%] bg-[#1973eb] relative flex justify-between align-middle items-center text-white font-semibold p-2 border border-white">
                    Description
                    <div className="flex absolute right-2 top-0 flex-col">
                      <div
                        className="cursor-pointer"
                        onClick={() => handleExpenseSort('description')}

                      >
                        <ArrowDropUp
                          sx={{
                            fontSize: "22px",
                            color: sortConfig.key === 'designation' && sortConfig.direction === 'ascending' ? '#ffeb3b' : 'white'
                          }}
                        />
                      </div>
                      <div
                        className="cursor-pointer -mt-2"
                        onClick={() => handleExpenseSort('description')}

                      >
                        <ArrowDropDown
                          sx={{
                            fontSize: "22px",
                            color: sortConfig.key === 'designation' && sortConfig.direction === 'descending' ? '#ffeb3b' : 'white'
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="w-[50%] bg-[#1973eb] relative flex justify-between align-middle items-center text-white font-semibold p-2 border border-white">
                    Cost
                    <div className="flex absolute right-2 top-0 flex-col">
                      <div
                        className="cursor-pointer"
                        onClick={() => handleExpenseSort('cost')}

                      >
                        <ArrowDropUp
                          sx={{
                            fontSize: "22px",
                            color: sortConfig.key === 'designation' && sortConfig.direction === 'ascending' ? '#ffeb3b' : 'white'
                          }}
                        />
                      </div>
                      <div
                        className="cursor-pointer -mt-2"
                        onClick={() => handleExpenseSort('cost')}

                      >
                        <ArrowDropDown
                          sx={{
                            fontSize: "22px",
                            color: sortConfig.key === 'designation' && sortConfig.direction === 'descending' ? '#ffeb3b' : 'white'
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  
                  <div className="w-[4%] flex gap-1 justify-center align-middle items-center bg-[#1973eb] p-1 border border-white group-hover:bg-[#b8c4f0]">
                    <div className="py-1 flex justify-center align-middle items-center text-md">
                      <DeleteIcon className="deleteicon cursor-pointer text-white" />
                    </div>
                  </div>
                </div>

                {filteredExpenseRows?.map((row) => (
                  <div
                    key={row.id}
                    className="flex expense w-full group"
                  >
                    <div className="w-[50%] p-2 flex align-middle items-center border border-white bg-[#cbd4f7]">
                      <input
                        type="text"
                        value={row.description}
                        onChange={(e) => handleOtherExpenseInputChange(e, row.id, "description")}
                        placeholder="Enter description"
                        className="w-full p-2 outline-none bg-transparent text-black"
                      />
                    </div>
                    <div className="w-[50%] p-2 flex align-middle items-center border border-white bg-[#cbd4f7]">
                      
                      <input
                        type="text"
                        value={row.cost}
                        onChange={(e) => {
                          let value = e.target.value;

                          if (/^\d*\.?\d{0,3}$/.test(value) || value === "") {
                            handleOtherExpenseInputChange(
                              {
                                ...e,
                                target: { ...e.target, value },
                              },
                              row.id,
                              "cost"
                            );
                          }
                        }}
                        placeholder="Enter cost"
                        className="w-full p-2 outline-none bg-transparent text-black"
                      />
                    </div>
                    
                    <div
                      className="w-[4%] flex gap-1 justify-center align-middle items-center pr-2 bg-[#cbd4f7] p-1 border border-white"
                    >
                      <div className="deleteicondiv py-1 flex justify-center align-middle items-center text-md opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                        <DeleteIcon
                          className="deleteicon cursor-pointer text-[#df3b3b] hover:text-[#c12a2a]"
                          onClick={() => handleexpenseDeleteRow(row._id)}
                        />
                      </div>
                    </div>
                  </div>
                ))}


                <div className="Otherboxbutoons flex justify-center items-center w-full relative mt-2 mb-4">
                  <div
                    className="absolute left-0 top-0 rounded-md p-1 shadow-lg border flex justify-center items-center bg-white cursor-pointer"
                    onClick={handleAddOtherExpenseRow}
                  >
                    <AddIcon className="text-black" />
                  </div>
                
                </div>
              </div>
            </div> */}

            <div className="flex justify-end pt-8 pr-[2rem]">
              <button
                onClick={handleSaveExpense}
                className={`px-4 py-2 font-semibold rounded-md ${isViewOnly
                  ? "bg-[#d1d5db] text-[#9ca3af] cursor-not-allowed pointer-events-none"
                  : "bg-[#1973eb] text-white"
                }`}
                disabled={isViewOnly || isLoading}
              >
                Save
              </button>
            </div>
          </div>
        </div>
        {isModalOpen && (
          <div className="fixed inset-0 flex items-center justify-center z-[1400] bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] max-w-md">
              <h2 className="text-xl font-semibold mb-4 text-center">
                Confirm Deletion
              </h2>
              <p className="text-gray-700 mb-6 text-center">
                Are you sure you want to delete this Hourly Rates?
              </p>
              <div className="flex justify-end gap-3">
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="px-4 py-2 rounded-md border border-gray-300 bg-gray-100 hover:bg-gray-200 text-gray-700"
                >
                  Cancel
                </button>
                <button
                  onClick={confirmDelete}
                  className="px-4 py-2 rounded-md bg-red-600 hover:bg-red-700 text-white font-semibold"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}

        {isexpenseModalOpen && (
          <div className="fixed inset-0 flex items-center justify-center z-[1400] bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] max-w-md">
              <h2 className="text-xl font-semibold mb-4 text-center">
                Confirm Deletion
              </h2>
              <p className="text-gray-700 mb-6 text-center">
                Are you sure you want to delete this Other Expenses?
              </p>
              <div className="flex justify-end gap-3">
                <button
                  onClick={() => setisexpenseModalOpen(false)}
                  className="px-4 py-2 rounded-md border border-gray-300 bg-gray-100 hover:bg-gray-200 text-gray-700"
                >
                  Cancel
                </button>
                <button
                  onClick={confirmExpenseDelete}
                  className="px-4 py-2 rounded-md bg-red-600 hover:bg-red-700 text-white font-semibold"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}

        {isModal && (
          <div className="fixed inset-0 flex items-center justify-center z-[1400] bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] max-w-md">
              <h2 className="text-xl font-semibold mb-4 text-center">
                Confirm Deletion
              </h2>
              <p className="text-gray-700 mb-6 text-center">
                Are you sure you want to delete this Hourly Rates?
              </p>
              <div className="flex justify-end gap-3">
                <button
                  onClick={() => setIsModal(false)}
                  className="px-4 py-2 rounded-md border border-gray-300 bg-gray-100 hover:bg-gray-200 text-gray-700"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    setRows((prevRows) =>
                      prevRows.filter((_, i) => i !== index)
                    );
                    setIsModal(false);
                    enqueueSnackbar("Row Deleted Successfully", {
                      variant: "success",
                    });
                  }}
                  className="px-4 py-2 rounded-md bg-red-600 hover:bg-red-700 text-white font-semibold"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    </>
  );
};

export default HourlyRatesManager;
